import { createAction } from 'redux-act';

import * as globalSettings from '../../core/globalSettings';


export const fetchGlobalSettings = createAction(
  'get all global settings',
);
export const fetchGlobalSettingsSuccess = createAction(
  'get all global settings success',
  (allGlobalSettings) => allGlobalSettings
);
export const fetchGlobalSettingsFail = createAction(
  'get all global settings fail',
  (error) => error
);

export const updateSetting = createAction(
  'update setting',
);
export const updateSettingSuccess = createAction(
  'update setting success',
  (setting) => setting
);
export const updateSettingFail = createAction(
  'update setting fail',
  (error) => error
);

export const reducer = {
  [fetchGlobalSettings]: (state, payload) =>
    globalSettings.fetchGlobalSettings(state, payload),
  [fetchGlobalSettingsSuccess]: (state, payload) =>
    globalSettings.fetchGlobalSettingsSuccess(state, payload),
  [fetchGlobalSettingsFail]: (state, payload) =>
    globalSettings.fetchGlobalSettingsFail(state, payload),

  [updateSetting]: (state, payload) =>
    globalSettings.updateSetting(state, payload),
  [updateSettingSuccess]: (state, payload) =>
    globalSettings.updateSettingSuccess(state, payload),
  [updateSettingFail]: (state, payload) =>
    globalSettings.updateSettingFail(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/globalSettings.module.js
 **/